import React from 'react'
import PropTypes from 'prop-types'
import { PartnersGridImage, PartnersGridMain, BrandTitle } from './index.style'
import Container from '@components/Container'
import Spacer from '@components/Spacer'
import { GatsbyImage } from 'gatsby-plugin-image'
import BrandsGrid from '../BrandsGrid'
import { Heading2Serif } from '@components/TextStyles'
import useGetColor from '../useGetColor'
import PageTransitionLink from '@components/PageTransitionLink'

const PartnersGrid = ({ data, backgroundColor: bgColor, textColor: tColor, parentService}) => {
  const {partnerItems: items, title, background, titleStyle, useDarkLogos} = data;
  const [backgroundColor, textColor] = useGetColor(background, bgColor, tColor)

  const getItemImage = (item) => {
    if(useDarkLogos) {
      if(item.darkImage) {
        return <GatsbyImage
            image={item.darkImage.gatsbyImageData}
            alt={item.darkImage.description}
            width={170}
            height={170}
        />
      }else {
        return <GatsbyImage
            image={item.featuredImage.gatsbyImageData}
            alt={item.featuredImage.description}
            width={170}
            height={170}
        />
      }
    }else {
      if(item.lightImage) {
        return <GatsbyImage
            image={item.lightImage.gatsbyImageData}
            alt={item.lightImage.description}
            width={170}
            height={170}
        />
      }else {
        return <GatsbyImage
            image={item.featuredImage.gatsbyImageData}
            alt={item.featuredImage.description}
            width={170}
            height={170}
        />
      }
    }
} 

  const carouselItems = items.map(brand => (
    <PartnersGridImage>
      <PageTransitionLink to={`what-we-do/${parentService}/${brand.slug}`}>
        {getItemImage(brand)}
      </PageTransitionLink>
    </PartnersGridImage>
  ))

  return (
    <PartnersGridMain color={textColor} background={backgroundColor}>
      <Container>
        <Spacer size={[70, 110]} />
        <>
          {(titleStyle === "Signifier Light") ?
            <Heading2Serif maxWidth={11}>{title}</Heading2Serif>
            :
            <BrandTitle>{title}</BrandTitle>
          }
        </>

        <Spacer size={[20, 70]} />

        <BrandsGrid items={carouselItems} itemsPerRow={6} />

        <Spacer size={[50, 110]} />
      </Container>
    </PartnersGridMain>
  )
}

PartnersGrid.propTypes = {
  data: PropTypes.object,
  bgColor: PropTypes.string,
  tColor: PropTypes.string,
  parentService: PropTypes.string
}

export default PartnersGrid
